/*
 * action types
 */
export const ANNOTATIONS = 'ANNOTATIONS'

/*
 * action creators
 */
export default function setAnnotations(payload) {
  return {
    payload,
    type: ANNOTATIONS,
  }
}
